import swal from 'sweetalert2'

import { faExclamationTriangle, faToggleLargeOn } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Box, Button, Text } from '@domain-group/suit-theme'

import useProviderPriceList, { UseProviderPriceListPayload } from '@hooks/useProviderPriceList'

import handleCallbackAction from '@functions/handleCallbackAction'

const confirmEnablePriceList = (
  unarchiveProviderPriceList: UseProviderPriceListPayload['callbacks']['unarchiveProviderPriceList'],
) => {
  const unarchivePriceListPayload = {
    callbacks: {
      action: unarchiveProviderPriceList,
    },
    toastText: 'Price List Enabled',
  }

  swal.fire({
    confirmButtonColor: '#DD6B55',
    confirmButtonText: 'Yes, enable it.',
    icon: 'warning',
    showCancelButton: true,
    text: 'Are you sure?',
    title: 'Enable Price List?',
  }).then(({ value }) => {
    if (value){
      // @ts-expect-error TS2345
      handleCallbackAction(unarchivePriceListPayload)
    }
  })
}

type PriceListArchivedBannerProps = {
  providerPriceListPayload: ReturnType<typeof useProviderPriceList>,
}

const PriceListArchivedBanner = (props: PriceListArchivedBannerProps) => {
  const { providerPriceListPayload } = props

  const {
    callbacks: { unarchiveProviderPriceList },
    providerPriceList: { hidden },
  } = providerPriceListPayload

  if (!hidden) return null

  return (
    <Box alignItems="center" flexDirection={['column', 'row']} marginBottom="large" padding="large" variant="white">
      <Box>
        <Box
          backgroundColor="orange"
          borderRadius={5}
          color="white"
          fontSize="large"
          padding="large"
          width="fit-content"
        >
          <FontAwesomeIcon icon={faExclamationTriangle} />
        </Box>

        <Box flexDirection="column" justifyContent="center" marginLeft="large">
          <Text fontSize="small" marginBottom="small">Price List is Archived</Text>

          <Text fontSize="small" color="bodyFontLightColor" marginTop="small">
            This Price List has been archived.
          </Text>
        </Box>
      </Box>

      <Button
        buttonStyle="secondaryUtility"
        //@ts-expect-error
        height="fit-content"
        icon={<FontAwesomeIcon icon={faToggleLargeOn} />}
        marginTop={['large', 0]}
        onClick={() => confirmEnablePriceList(unarchiveProviderPriceList)}
        size="medium"
        width={['100%', 'fit-content']}
      >
        Enable Price List
      </Button>
    </Box>
  )
}

export default PriceListArchivedBanner
